import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { canPerformAnyAction } from '~src/resourceActions/selectors/ResourceActionsSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { areAllSelectedUsersServerAdmins, isSingleSelectSiteUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { siteUserRemove } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserRemoveAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserRemove,
  translateName: Messages.removeSiteUserAction,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
    // - Disallow if the only selection is a guest user.
    // - Disallow site admins from attempting to remove a set of all server admins
    const passesCommonChecks = targetItems.length > 0
      && !isSingleSelectSiteUserGuest(targetItems)
      && (!areAllSelectedUsersServerAdmins(targetItems) || SessionUserSelectors.isSessionServerAdmin(state))
      && state.spaceInfo.spaceType === 'siteusers';

    // canManageUsers: always true for Server Admins, conditionally true for Site Admins based on site setting.
    // When isAdminProfilesEnabledOnServer, also allow users who have been granted REMOVE_FROM_SITE via resource actions.
    const hasAccess = SessionUserSelectors.canManageUsers(state)
      || (SessionServerSelectors.isAdminProfilesEnabledOnServer(state) && canPerformAnyAction(state, 'User', ['REMOVE_FROM_SITE']));

    return passesCommonChecks && hasAccess;
  },
  isClickable: (_availableActions: {}, _targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserRemove(targetItems)
};
